import React, { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import { useLegislativnyMaterialDetail } from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import { VseobecnyObalMaterialuWrapper } from '../../../module/SprievodnyDokument/CreateFromForm';
import SuccessMessages from '../../../module/SuccessMessages';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';

const VseobecnyObalMaterialuCreatePage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year: yearParam,
    index: indexParam,
    stadium,
    stadiumUuid,
  } = useParams();
  const year = parseInt(yearParam, 10);
  const index = parseInt(indexParam, 10);
  const stadiumEnum = StadiumMaterialuEnum[stadium];

  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Voľba typu formulára',
          to: routes.procesy.detail.sprievodneDokumenty.obalMaterialu.select
            .withParams(type, year, index, stadiumUuid, stadiumEnum),
        },
        {
          heading: 'Obal materiálu',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          hasOpravneniePracovneKroky={materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
            <>
              <PageHeadingWithBackButton
                headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                heading="Obal materiálu"
                withBackLink
              />
              <VseobecnyObalMaterialuWrapper
                materialUuid={materialDetail.uuid}
                type={type}
                year={year}
                index={index}
                stadium={stadiumEnum}
                stadiumUuid={stadiumUuid}
              />
            </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default VseobecnyObalMaterialuCreatePage;
